package com.eladfinish.bible.contest.common.gender

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.gender_female
import com.eladfinish.bible.contest.gender_male
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.StringResource

enum class HebrewGender(val stringResource: StringResource) {
    MALE(stringResource = SharedRes.strings.gender_male),
    FEMALE(stringResource = SharedRes.strings.gender_female);
}

// example:
// <string name="check_update">[{בדוק/בדקי}] עדכון</string>
fun String.personalizeGender(hebrewGender: HebrewGender): String =
    replaceRegex(
        regex = "\\[\\{(.*?)/(.*?)\\}\\]",
        replacement = when (hebrewGender) {
            HebrewGender.MALE -> "$1"
            HebrewGender.FEMALE -> "$2"
        }
    )

fun Settings.getHebrewGender(): HebrewGender {
    getString(
        key = Constants.PREF_HEBREW_GENDER_LANGUAGE,
        defaultValue = HebrewGender.MALE.name.lowercase()
    ).let {
        return enumValueOf(it.uppercase())
    }
}
